import React, { useState } from 'react';
import Carousel from '../../Component/Home/Carousel/Carousel';
import SideBar from '../../Component/Shared/SideBar/SideBar';
// import { useLoaderData } from 'react-router-dom';
import './homepage.css';

const HomePage = () => {
    // Static home page content - commented out API loader
    const staticHomeContent = {
        content: `2<sup>nd</sup> International Conference on Engineering and Technology for Sustainable Development (ETSD 2026) aims to bring together researchers, engineers, and practitioners worldwide to present and discuss the latest advancements and innovations in emerging technologies. The conference seeks collaboration and knowledge exchange to address global challenges and promote sustainable development. Topics of interest include but are not limited to, renewable energy, smart infrastructure, green manufacturing, conventional and unconventional petroleum resources, marine resources, and environmental protection. ETSD 2026 aims to provide a platform for interdisciplinary dialogue and to inspire actionable solutions for a sustainable future.`
    };

    // const loadedInfo = useLoaderData();
    // const [HomePageMassage, setHomePageMassage] = useState(loadedInfo.data[0]);
    const [HomePageMassage, setHomePageMassage] = useState(staticHomeContent);
    
    return (
        <div className='my-5 bcolor'>
            <div>
                <Carousel />
            </div>
            <div className='container my-5'>
                <div className='row'>
                    <div className='col-lg-10 col-xl-9 content-area'> 
                        {HomePageMassage ? (
                            <div 
                                className='article-content'
                                dangerouslySetInnerHTML={{ __html: HomePageMassage.content }}
                            />
                        ) : (
                            <div className='text-center py-5'>
                                <h2>Content Coming Soon</h2>
                                <p className='text-muted'>Please check back later</p>
                            </div>
                        )}
                    </div>
                    <div className='col-lg-2 col-xl-3'>
                        <SideBar />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HomePage;